import React from 'react';
import Stylesheet from './Toolbox.module.css';
import Button from '../../../../elements/Button/Button';
import { ico_check, ico_plus, ico_times, ico_trash } from '../../../../icon';
import {user, storage} from '@enigma/core/services';
import { AppContext } from '../../../../contexts/app';
import { useHistory } from 'react-router-dom';
import Columns from './Columns/Columns';
import Data from './Data/Data';
import Reports from './Reports/Reports';
import { TableContext } from '../../context/table';
import { QueryContext } from '../../context/query';
import { addNewRecord, deleteRecord } from '../../Table.Engine';

const Toolbox = (props) => {
    let history = useHistory();
    let app = null;
    let table = null;
    let query = null;
    const init = (appContext, tableContext, queryContext) => {
        app = appContext;
        table = tableContext;
        query = queryContext;
    } 
    // add new record to table
    const onAddRecords = _ => {
        if (!table?.schema) {
            app.toggleToast(ico_times, 
                'table does not have any columns yet', true);
            return;
        }
        let metadata = {
            isNew: true, // record is incomplete
            timestamp: Date.now(),
            author: user.displayName,
            branch: app.profile.branch
        };
        // prefill required fields with its default values for static tables
        if (!table.config.custom) {
            for (const schema of table.schema) {
                if (schema.required && schema.default)
                    metadata[schema.name] = schema.default
            }
        }
        // create new record instance
        addNewRecord(metadata, table.metadata);
    }
    const onDeleteRecords = async _ => {
        // confirm operation
        const response = await app.toggleMessageBox('confirm deletion', 
        `Are you sure you want to remove ${query?.selected.records.length} records ?.`+
        ' This can not be undone.', "yes_no");
        if (response === "yes") {
            let failed = [];
            for (const selectedRecord of query?.selected.records) {
                for (const record of table?.records) {
                    if (record.id === selectedRecord.id) {
                        // delete storage objects (if any)
                        for (const column of table?.schema) 
                            if (column.type === "file" && record[column.name])
                                await storage.delete(record[column.name].path)
                        // delete database record
                        await deleteRecord(record.id, table.metadata, table.config)
                        .catch(_ => failed.push(record.id))
                    }
                }
            }
            if (failed.length === 0) {
                app.toggleToast(ico_check, 'records successfuly removed');
                // clear record selection
                history.push("?select=")
            } else {            
                app.toggleToast(ico_times, 'some records could not be removed', true);
                // clear removed records from selection
                history.push(`?select=${failed.join(',')}`)
            }
        }
    }
    
    const content = config => {
        if (config?.toolbox) {
            return (
                <div className={Stylesheet.Toolbox}>
                    <div className={Stylesheet.ButtonGroup}>
                        <div className={Stylesheet.Group}>
                            <h5 className={Stylesheet.Title}>Manage records</h5>
                            {table?.config?.disableAdd ? null :
                            <Button onClick={_ => onAddRecords()} primary
                            disabled={table?.schema === undefined 
                            || query?.selected.records.length > 0 
                            || query?.selected.columns.length > 0
                            || query?.report.report ? true : false
                            || config?.lock}>
                            {ico_plus}&emsp;{table?.config?.addText || 'add record'}</Button>}
                            {table?.config?.disableDelete ? null
                            :<Button onClick={_ => onDeleteRecords()} secondary error
                            disabled={query?.selected.records.length === 0 
                            || query?.selected.columns.length > 0
                            || config?.lock}>
                            {ico_trash}&emsp;{table?.config?.deleteText || 'delete record'}</Button>}
                        </div>
                    </div>
                    <Columns />
                    {!config?.disableData ? <Data /> : null}
                    <Reports />
                </div>
            )
        }
        if (config?.basic) {
            return (
                <React.Fragment>
                    <div className={Stylesheet.Basic}>
                        {table?.config?.disableAdd ? null :
                        <Button onClick={_ => onAddRecords()} primary
                        disabled={table?.schema === undefined 
                        || query?.selected.records.length > 0 
                        || query?.selected.columns.length > 0
                        || query?.report.report ? true : false
                        || config?.lock}>
                        {ico_plus}&emsp;{table?.config?.addText || 'add record'}</Button>}
                        {table?.config?.disableDelete ? null
                        :<Button onClick={_ => onDeleteRecords()} secondary error
                        disabled={query?.selected.records.length === 0 
                        || query?.selected.columns.length > 0
                        || config?.lock}>
                        {ico_trash}&emsp;{table?.config?.deleteText || 'delete record'}</Button>}
                    </div>
                    <Reports  />
                </React.Fragment>
            )
        }
        return null;
    }

    return (
        <AppContext.Consumer>
            {app => (
                <TableContext.Consumer>
                    {table => (
                        <QueryContext.Consumer>
                            {query => (
                                <div className={Stylesheet.Container}>
                                    {init(app, table, query)}
                                    {content(table.config)}
                                </div>
                            )}
                        </QueryContext.Consumer>
                    )}
                </TableContext.Consumer>
            )}
        </AppContext.Consumer>
    )
}

export default Toolbox;